import { axiosInstance } from "@/helper/axios-instance";
import { useMutation } from "@tanstack/react-query";

type Args = {
  clientCode: string | undefined;
  externalCode: string | undefined;
  fileName: string;
  contentType?: string;
  showHiddenRows: boolean;
};

export function useNPVPrint() {
  return useMutation({
    mutationFn: async ({ clientCode, externalCode, fileName, showHiddenRows }: Args) => {
      const response = await axiosInstance({
        method: "POST",
        responseType: "arraybuffer",
        data: {
          clientCode,
          externalCode,
          showHiddenRows,
        },
        url:
          
          `Salesforce/PrintNPV`,
      });
      return { response, fileName };
    },
    onSuccess: (data) => {
      const { response, fileName } = data;

      const blob = new Blob([response.data], { type: "application/octetstream" });

      const url = window.URL || window.webkitURL;
      const link = url.createObjectURL(blob);
      const a = document.createElement("a");

      a.setAttribute("download", fileName);
      a.setAttribute("href", link);
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    },
  });
}
